<template>
  <v-app class="app-background">
    <div class="welcome-page">
      <el-card shadow="always" class="welcome-container pa-3">
        <img src="../../assets/logoFix.png" alt srcset class="welcome-image mb-4" />
        <el-row class="custom-card-success-reset-password" type="flex" justify="center">
          <el-col :span="24">
            <el-card shadow="never">
                <h2 style="color: #409EFF">Password Anda Telah Berhasil Diubah</h2>
            </el-card>
          </el-col>
        </el-row>
      </el-card>
      <div class="bg-ellips"></div>
    </div>
  </v-app>
</template>

<script>
export default {
  data() {},
  methods: {},
  computed: {}
};
</script>

<style>
.custom-card-success-reset-password {
  border: 1px solid #409EFF;
}
</style>
